/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

import auth from '@/api/auth'
import get from 'lodash/get'

export const INITIAL_STATE = {
  needChgPwd: false,
  isVerifying: false,
  token: null,
  toVerify: null,
  account: null,
  forceLogout: false,
  forbidden: false,
}

export default {
  namespace: 'auth',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    loggedInInit(state) {
      return { ...state, needChgPwd: false, toVerify: null }
    },
    forceLogout(state) {
      return { ...state, forceLogout: true }
    },
    forbidden(state) {
      return { ...state, forbidden: true }
    },
    closeForbiddenModal(state) {
      return { ...state, forbidden: false }
    },
    setToken(state, { payload }) {
      return { ...state, token: get(payload, 'token'), refresh: get(payload, 'refresh') }
    },
    setVerifying(state, { payload }) {
      return {
        ...state,
        needChgPwd: get(payload, 'needChgPwd'),
        isVerifying: get(payload, 'isVerifying'),
      }
    },
    setToVerify(state, { payload }) {
      return {
        ...state,
        toVerify: get(payload, 'toVerify'),
      }
    },
    setAccount(state, { payload }) {
      return {
        ...state,
        account: get(payload, 'account'),
      }
    },
  },

  effects: {
    *getAccountData({ successCallback, errorCallback }, { call, put }) {
      const response = yield call(auth.me)
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { data, success } = resData

        if (success) {
          yield put({ type: 'auth/setAccount', payload: { account: data } })

          hasError = false

          successCallback?.()
        }
      }

      if (hasError) {
        errorCallback?.(resData?.message)
      }
    },

    *login({ payload, successCallback, errorCallback, forceLogin }, { call, put }) {
      const response = yield call(auth.login, payload)
      const { status, data: resData } = response
      let hasError = true

      if (status === 200 || forceLogin) {
        const { data, success } = resData

        if (success || forceLogin) {
          const { authOutcome, needChgPwd = false } = data || {}

          hasError = false

          yield put({
            type: 'auth/setVerifying',
            payload: { needChgPwd, isVerifying: forceLogin || authOutcome },
          })

          yield put({
            type: 'profile/setProfile',
            payload: { username: payload.username },
          })

          yield put({
            type: 'auth/setToVerify',
            payload: {
              toVerify: { action: 'auth/loginVerify' },
            },
          })

          successCallback?.()
        }
      }

      if (hasError) {
        errorCallback?.(resData?.message)
      }
    },

    *loginVerify({ payload, successCallback, errorCallback }, { call, put, select }) {
      const response = yield call(auth.loginVerify, payload)
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { data, success } = resData

        if (success) {
          const { needChgPwd } = yield select(state => state.auth)
          const { token, refresh } = data

          if (token && refresh) {
            hasError = false

            yield put({
              type: 'auth/setToken',
              payload: { token, refresh },
            })

            if (needChgPwd) {
              successCallback?.('/reset_password')
            } else {
              yield put({ type: 'auth/loggedInInit' })

              successCallback?.('/account')
            }
          }
        }
      }

      if (hasError) {
        errorCallback?.(resData?.message)
      }
    },

    *resetPassword({ payload, successCallback, errorCallback }, { call, put }) {
      const response = yield call(auth.resetPassword, payload)
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false
          yield put({ type: 'auth/init' })
          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.(resData?.message)
      }
    },

    *requestResetPassword({ payload, successCallback, errorCallback }, { call, put }) {
      const response = yield call(auth.requestResetPassword, payload)
      const { status, data: resData } = response
      let hasError = true
      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false

          yield put({
            type: 'auth/setVerifying',
            payload: { isVerifying: true },
          })

          yield put({
            type: 'profile/setProfile',
            payload: { username: payload.username },
          })

          yield put({
            type: 'auth/setToVerify',
            payload: {
              toVerify: { action: 'auth/resetPasswordVerify' },
            },
          })

          successCallback?.()
        }
      }
      if (hasError) {
        errorCallback?.(resData?.message)
      }
    },

    *resetPasswordVerify({ payload, successCallback, errorCallback }, { call }) {
      const response = yield call(auth.requestResetPasswordVerify, payload)
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success } = resData

        if (success) {
          hasError = false

          successCallback?.('/admin/login')
        }
      }

      if (hasError) {
        errorCallback?.(resData?.message)
      }
    },

    *logout(_, { put }) {
      yield put({ type: 'auth/init' })
    },
  },
}
